import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { role: "navigation" }
const _hoisted_2 = { class: "page" }
const _hoisted_3 = { class: "navbar-container" }
const _hoisted_4 = { class: "hem" }
const _hoisted_5 = ["href"]
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "hemtext" }

import { RouteLocationNormalizedLoaded, useRouter } from "vue-router";
import { ref, watch } from "vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'NavigationBar',
  setup(__props) {

const router = useRouter();

const frontendUrl = ref<string>(process.env.VUE_APP_FRONTEND_URL);
const currentRoute = ref<RouteLocationNormalizedLoaded>(router.currentRoute.value);

watch(
  () => router.currentRoute.value,
  (to: RouteLocationNormalizedLoaded) => {
    currentRoute.value = to;
  }
);


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass({'navbar-inner': currentRoute.value.path === '/'})
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("a", {
              class: "router-link home-button header-button primary",
              href: frontendUrl.value,
              "aria-label": "Hem, till startsidan för Stå kvar i Bolagsverkets register"
            }, [
              _createElementVNode("img", {
                class: "hemikon",
                src: require('@/../public/images/home_white.svg'),
                alt: ""
              }, null, 8, _hoisted_6),
              _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t("hem")), 1)
            ], 8, _hoisted_5)
          ])
        ])
      ], 2)
    ])
  ]))
}
}

})